import {useTranslation} from "react-i18next";

import ReactTable from "../../conteiners/ReactTable";
import NewPdfViewer from "../../Project/Documents/DocumentView/NewPdfViewer";
import useColumns from "../../Requests/OrderProcessing/utils/hooks/useColumns";
import Title from "../../UI/Title/Title";

import {
  PLANNING_DETAILS_DIMENSION_COLUMNS,
  PLANNING_DETAILS_DOCUMENT_COLUMNS,
  PLANNING_DETAILS_REQUEST_COLUMNS,
} from "./constants";

const PlanningDetailsPanel = () => {
  const {t} = useTranslation();
  const requestColumns = useColumns(PLANNING_DETAILS_REQUEST_COLUMNS);
  const documentColumns = useColumns(PLANNING_DETAILS_DOCUMENT_COLUMNS);
  const dimensionColumns = useColumns(PLANNING_DETAILS_DIMENSION_COLUMNS);

  return (
    <div
      className="fdr aistr w100 h100"
      style={{minHeight: 0, minWidth: 0, backgroundColor: "white", border: "1px solid #A3B9D9"}}
    >
      <div className="fcCol aistr h100 padding5" style={{flex: "0 0 60%", minHeight: 0, minWidth: 0}}>
        <div className="w100 mb5">{t("Documents SP №")}</div>

        <div className="fcCol aistr w100" style={{flex: "1 1 0", minHeight: 0}}>
          <Title number={1} text="Requests" className="w100" />
          <ReactTable
            columns={requestColumns}
            defaultData={[]}
            className="w100 scrollX"
            enableColumnResizing
            selectable={false}
          />
        </div>

        <div className="fcCol aistr w100" style={{flex: "1.15 1 0", minHeight: 0}}>
          <Title number={2} text="Documents" className="w100" />
          <ReactTable
            columns={documentColumns}
            defaultData={[]}
            className="w100 scrollX"
            enableColumnResizing
            selectable={false}
          />
        </div>

        <div className="fcCol aistr w100" style={{flex: "1.65 1 0", minHeight: 0}}>
          <Title number={3} text="Dimensions" className="w100" />
          <ReactTable
            columns={dimensionColumns}
            defaultData={[]}
            className="w100 scrollX"
            enableColumnResizing
            selectable={false}
          />
        </div>
      </div>

      <div className="h100" style={{flex: "1 1 auto", minHeight: 0, minWidth: 0, borderLeft: "1px solid #A3B9D9"}}>
        <NewPdfViewer fileArray={[]} hiding={false} showEmptyStateIcon />
      </div>
    </div>
  );
};

export default PlanningDetailsPanel;
